'use client'

import { useEffect, useState } from 'react'

export function LazyLivePreview() {
  const [Component, setComponent] = useState<React.ComponentType | null>(null)

  useEffect(() => {
    import('./index').then((m) => setComponent(() => m.LivePreviewListener))
  }, [])

  if (!Component) return null
  return <Component />
}
